import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import StoreDetail from './pages/store-detail';
import EventsAndPromotions from './pages/events-and-promotions';
import StoreDirectory from './pages/store-directory';
import ContactAndLocation from './pages/contact-and-location';
import BuildingInformation from './pages/building-information';
import Sustainability from './pages/sustainability';
import ResidentialApartments from './pages/residential-apartments';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/store-detail" element={<StoreDetail />} />
        <Route path="/events-and-promotions" element={<EventsAndPromotions />} />
        <Route path="/store-directory" element={<StoreDirectory />} />
        <Route path="/contact-and-location" element={<ContactAndLocation />} />
        <Route path="/building-information" element={<BuildingInformation />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/residential-apartments" element={<ResidentialApartments />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
